export default __webpack_public_path__ + "static/media/20180808_164113.e1cff847.jpg";